const CLOUD_NAME = "dwnnt4ism";

export const CLOUDINARY_RAW_BASE_URL = `https://res.cloudinary.com/${CLOUD_NAME}/raw/upload`;
export const CLOUDINARY_TIFF_BASE_URL = `https://res.cloudinary.com/${CLOUD_NAME}/image/upload`;
// Pour les images comme les légendes et les images de téléchargement
// export const CLOUDINARY_IMAGE_BASE_URL = `https://res.cloudinary.com/${CLOUD_NAME}/image/upload/`;

export const CLOUDINARY_TIF_FOLDER = "profile/assets/geotiff_data";
export const CLOUDINARY_GEOJSON_SIG_FOLDER = "profile/assets/geojson_data";
export const CLOUDINARY_GEOJSON_BOUNDARY_FOLDER = "profile/assets/data";
export const CLOUDINARY_IMPACTS_GEOJSON_FOLDER =
  "profile/assets/impacts/geojson_data";

export const CLOUDINARY_IMPACTS_TIF_FOLDER =
  "profile/assets/impacts/geotiff_data_yield_gap"; // Dossier spécifique pour TIF Yield Gap
// export const CLOUDINARY_IMPACTS_GEOJSON_FOLDER = 'profile/assets/impacts/geojson_data_cwd';

// export const CLOUDINARY_LEGEND_FOLDER = 'profile/assets/legends';
// export const CLOUDINARY_DOWNLOAD_FOLDER = 'profile/assets/data_download';
